import { Instagram, MapPin, Phone, MessageCircle, Mail } from "lucide-react";
import { SITE } from "@/config/site";
import { Logo } from "./Logo";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-brand-ink text-white pt-16 pb-8">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
        <div>
          <Logo dark />
          <p className="mt-5 text-sm text-white/55 leading-relaxed max-w-xs">
            Trasteros seguros, modernos y de fácil acceso para particulares y empresas en Guadalajara.
          </p>
          {SITE.instagramUrl && (
            <a
              data-testid="footer-instagram-link"
              href={SITE.instagramUrl}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram de OtraRoom"
              className="mt-5 inline-flex items-center justify-center w-11 h-11 rounded-full border border-white/20 hover:bg-brand-yellow hover:text-brand-ink hover:border-brand-yellow transition-[background-color,color,border-color] duration-200"
            >
              <Instagram size={19} />
            </a>
          )}
        </div>

        <div>
          <h3 className="font-mono text-[11px] font-bold tracking-[0.3em] uppercase text-brand-yellow">Contacto</h3>
          <ul className="mt-5 space-y-4 text-sm">
            <li className="flex items-start gap-3 text-white/70">
              <MapPin size={17} className="text-brand-yellow shrink-0 mt-0.5" />
              <span>{SITE.address} · {SITE.city}</span>
            </li>
            <li>
              <a href={SITE.phoneHref} data-testid="footer-phone-link" className="flex items-center gap-3 text-white/70 hover:text-brand-yellow transition-colors">
                <Phone size={17} className="text-brand-yellow shrink-0" />
                {SITE.phoneDisplay}
              </a>
            </li>
            <li>
              <a href={SITE.emailHref} data-testid="footer-email-link" className="flex items-center gap-3 text-white/70 hover:text-brand-yellow transition-colors break-all">
                <Mail size={17} className="text-brand-yellow shrink-0" />
                {SITE.emailDisplay}
              </a>
            </li>
            <li>
              <a href={SITE.whatsappUrl} target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp-link" className="flex items-center gap-3 text-white/70 hover:text-brand-yellow transition-colors">
                <MessageCircle size={17} className="text-brand-yellow shrink-0" />
                WhatsApp directo
              </a>
            </li>
          </ul>
        </div>

        <div>
          <h3 className="font-mono text-[11px] font-bold tracking-[0.3em] uppercase text-brand-yellow">Legal</h3>
          <ul className="mt-5 space-y-3 text-sm">
            <li><a data-testid="footer-legal-aviso" href="/legal/aviso-legal" className="text-white/70 hover:text-brand-yellow transition-colors">Aviso legal</a></li>
            <li><a data-testid="footer-legal-privacidad" href="/legal/politica-de-privacidad" className="text-white/70 hover:text-brand-yellow transition-colors">Política de privacidad</a></li>
            <li><a data-testid="footer-legal-cookies" href="/legal/politica-de-cookies" className="text-white/70 hover:text-brand-yellow transition-colors">Política de cookies</a></li>
          </ul>
        </div>
      </div>

      <div className="mt-14 pt-7 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-3 text-xs text-white/40">
        <span>© {new Date().getFullYear()} OtraRoom Trasteros · Guadalajara</span>
        <span className="font-mono tracking-[0.2em] uppercase">El espacio que te falta</span>
      </div>
    </div>
  </footer>
);
